import FeatherIcon from "feather-icons-react";
import React, { FC } from "react";

import { IconButton } from "@components/base";
import { useDeleteDraftTableRow } from "@api";
import { useUserStore } from "@store/user";

interface RemoveRowButton {
  formId: string;
  sectionCode: string;
  questionCode: string;
  rowIndex: number;
}

const RemoveRowButton: FC<RemoveRowButton> = ({
  formId,
  sectionCode,
  questionCode,
  rowIndex,
}) => {
  const { user } = useUserStore();
  const { deleteDraftTableRowAsync, deleteDraftTableRowEnabled } =
    useDeleteDraftTableRow(user, {
      formId,
      sectionCode,
      questionCode,
      rowIndex,
    });

  const handleRemoveRow = async (): Promise<void> => {
    await deleteDraftTableRowAsync();
  };

  return (
    deleteDraftTableRowEnabled && (
      <IconButton size="small" color="error" onClick={handleRemoveRow}>
        <FeatherIcon icon="trash-2" size={16} />
      </IconButton>
    )
  );
};

export default RemoveRowButton;
